import { render, staticRenderFns } from "./TransactionGroupTitle.vue?vue&type=template&id=4bdb785a&"
import script from "./TransactionGroupTitle.vue?vue&type=script&lang=js&"
export * from "./TransactionGroupTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports